import styled, { css } from "styled-components";

export const StyledPopupWrapper = styled.div`
    position: relative;
`;

export const StyledPopup = styled.div`
    position: absolute;
    width: ${({ width }) => width};
    ${({ positionVertical }) => {
        if (positionVertical === 'top') {
            return css`
                top: 100%;
                margin-top: 15px;
            `
        } else if (positionVertical === 'bottom') {
            return css`
                bottom: 100%;
                margin-bottom: 15px;
            `
        }
    }};
     ${({ positionHorizontal }) => {
        if(positionHorizontal === 'left') {
            return css`
                left: -15px;
            `
        }
        else if(positionHorizontal === 'right') {
            return css`
                right: -15px;
            `
        }
    }};
`;
